import React from 'react';
import {
  Col, Divider, Modal, Row, textColor, Typography, Radio,
  RadioChangeEvent, useSwitchProfile,
  useTranslation, DetailText, camelCase, BasicButtonBG,
  SearchOutlined,
} from '@lib/index';
import { Input, Spin } from 'antd';
import { useFilteredRoles } from '@hooks/index';
import { ENV } from '@config/envConfig';

const SelectProfile = () => {
  const { Paragraph, Title } = Typography;
  const {
    roles, handleCancel, handleSelectProfile, setId, isModalVisible, id,
  } = useSwitchProfile();
  const onChange = (e: RadioChangeEvent) => setId(e.target.value);
  const { t } = useTranslation();
  const allowedRoles = (ENV.VITE_ALLOWED_ROLES || import.meta.env.VITE_ALLOWED_ROLES) as string;
  const { searchText, setSearchText, filteredRoles } = useFilteredRoles({
    roles,
    allowedRoles,
  });
  const isLoading = !roles;
  return (
    <Modal
      title={(
        <Title level={5} className={`${textColor.darkBlue}`}>
          {t('login.selectProfile')}
        </Title>
      )}
      visible={isModalVisible}
      displayButtons
      width={700}
      footer={(
        <Row justify="end">
          <BasicButtonBG
            text={t('login.cancel')}
            loading={false}
            onClick={handleCancel}
            data-cy="select-profile-cancel"
          />
          <BasicButtonBG
            text={t('login.submit')}
            loading={false}
            onClick={handleSelectProfile}
            type="primary"
            data-cy="select-profile-submit"
          />
        </Row>
      )}
    >
      <Row className="m-2">
        <Input
          placeholder={t('roles.searchProfile')}
          value={searchText}
          name="name"
          onChange={(e) => setSearchText(e.target.value)}
          className="mb-2"
          allowClear
          suffix={<SearchOutlined />}
        />
      </Row>
      <Spin spinning={isLoading}>
        <Row className="overflow-y-auto h-72 rounded pl-3">
          <Radio.Group onChange={onChange} value={id} size="large">
            {filteredRoles?.map((role) => (
              <Col xs={24} sm={24} md={24} lg={24} xl={24} key={role.id}>
                <Radio value={role.id} data-cy={`select-profile-role-${role.id}`}>
                  <Paragraph>
                    (
                    {t(`roles.${camelCase(role.category)}`)}
                    )
                    {' '}
                    <DetailText
                      content={role.roleLabel}
                      textColor={textColor.gray}
                    />
                  </Paragraph>
                  <Divider />
                </Radio>
              </Col>
            ))}
          </Radio.Group>
        </Row>
      </Spin>
    </Modal>
  );
};

export default SelectProfile;
